<template>
  <div class="-wt-mass-produce-confirm">
    <div class="-title">Ready to Start?</div>
    <div class="-subtitle">
      You are about to produce <strong v-text="numRows.toLocaleString()" />
      <span v-text="'video' + (numRows > 1 ? 's' : '')" />.<br />
      This process might take a while, we will notify you by email when ready.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numRows: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.-wt-mass-produce-confirm {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  .-title {
    font-size: 28px;
    font-weight: 300;
    margin-bottom: 30px;
  }
  .-subtitle {
    font-size: 14px;
    font-weight: 400;
  }
}
</style>
